/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Save_Art_FootInputs */

const en_services_svc_save_art_foot = /** @type {(inputs: Services_Svc_Save_Art_FootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source: Service guide · First consultation`)
};

const lv_services_svc_save_art_foot = /** @type {(inputs: Services_Svc_Save_Art_FootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avots: Pakalpojumu apraksts · Pirmā konsultācija`)
};

/**
* | output |
* | --- |
* | "Source: Service guide · First consultation" |
*
* @param {Services_Svc_Save_Art_FootInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_save_art_foot = /** @type {((inputs?: Services_Svc_Save_Art_FootInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Save_Art_FootInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_save_art_foot(inputs)
	return en_services_svc_save_art_foot(inputs)
});